module.exports = __webpack_public_path__ + "img/CAPT_Suyat.57a44f9f.jpg";